export default {
	name: 'Home',
    methods: {},
    computed: {},
};